import { render, staticRenderFns } from "./ReviewsBar.vue.html?vue&type=template&id=fd85fe7a&scoped=true&"
import script from "./ReviewsBar.component.js?vue&type=script&lang=vueJs&"
export * from "./ReviewsBar.component.js?vue&type=script&lang=vueJs&"
import style0 from "./ReviewsBar.scoped.scss?vue&type=style&index=0&id=fd85fe7a&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd85fe7a",
  null
  
)

export default component.exports